import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { partialRight, merge, over } from 'lodash';
import { compose } from 'recompose';
import { withRouter } from 'react-router';

import withValidatePassword from '../hoc/WithValidatePassword';
import ResetPassword from './components/ResetPassword';
import { resetPassword } from './actions';

class ResetPasswordContainer extends Component {
  static propTypes = {
    resetPassword: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
    errorMessage: PropTypes.string,
    successMessage: PropTypes.string,
    validatePassword: PropTypes.func.isRequired,
    validatePasswordWarning: PropTypes.string.isRequired,
  }

  static defaultProps = {
    isFetching: false,
    successMessage: '',
    errorMessage: '',
  }

  constructor(props) {
    super(props);

    this.state = {
      password: { value: '' },
      repeatPassword: { value: '', error: '' },
      valid: false,
    };

    this.handlePasswordChange = over([
      partialRight(this.handleInputChange, 'password').bind(this),
      this.props.validatePassword,
    ]);
    this.handleRepeatPasswordChange = partialRight(this.handleInputChange, 'repeatPassword').bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  comparePasswords() {
    if (this.state.password.value !== this.state.repeatPassword.value) return 'Passwords don\'t match!';

    return '';
  }

  validatePasswords(state) {
    const repeatPasswordError = this.comparePasswords();
    const valid = !repeatPasswordError;

    const newState = merge(state, {
      repeatPassword: { error: repeatPasswordError },
      valid,
    });

    return newState;
  }

  handleInputChange(e, field) {
    const nextState = (merge(this.state, {
      [field]: { value: e.target.value },
    }));

    this.setState(this.validatePasswords(nextState));
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.resetPassword(this.state.password.value);
  }

  render() {
    return (
      <ResetPassword
        passwordValue={this.state.password.value}
        repeatPasswordValue={this.state.repeatPassword.value}
        onPasswordChange={this.handlePasswordChange}
        onRepeatPasswordChange={this.handleRepeatPasswordChange}
        repeatPasswordError={this.state.repeatPassword.error}
        onSubmit={this.handleSubmit}
        valid={this.state.valid}
        errorMessage={this.props.errorMessage}
        successMessage={this.props.successMessage}
        isFetching={this.props.isFetching}
        validatePassword={this.props.validatePassword}
        validatePasswordWarning={this.props.validatePasswordWarning}
      />
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.confirmation.get('isFetching'),
  errorMessage: state.confirmation.get('errorMessage'),
  successMessage: state.confirmation.get('successMessage'),
});

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  resetPassword: resetPassword.bind(null, ownProps.params.token),
}, dispatch);

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withValidatePassword,
)(ResetPasswordContainer);



// WEBPACK FOOTER //
// ./src/app/confirmation/ResetPassword.jsx